import { SagaIterator } from 'redux-saga';
import apiClient from 'src/common/apiClient';
import {
  CreateMovementPayload,
  FetchMovementAssignmentsPayload,
  FetchMovementsPayload,
  UpdateMovementPayload,
} from 'src/common/types';

export function fetchMovementsApi(payload: FetchMovementsPayload): SagaIterator {
  const offset = payload.offset ? `&offset=${payload.offset}` : '';
  const limit = payload.limit ? `&limit=${payload.limit}` : '';
  const startTime = payload.startTimestamp ? `&startTimestamp=${payload.startTimestamp}` : '';
  const endTime = payload.endTimestamp ? `&endTimestamp=${payload.endTimestamp}` : '';
  return apiClient.get(
    `eld/movements/all/${payload.companyId}/${payload.powerUnitNumber}?status=${payload.status}${startTime}${endTime}${offset}${limit}`,
  );
}

export function fetchMovementAssignmentsApi(
  payload: FetchMovementAssignmentsPayload,
): SagaIterator {
  return apiClient.get(
    `eld/movements/assignments/${payload.employeeId}/?startTimestamp=${
      payload.startTimestamp
    }&endTimestamp=${payload.endTimestamp}${
      payload.assignmentStatus ? `&status=${payload.assignmentStatus}` : ''
    }`,
  );
}

export function claimMovementsApi(payload: CreateMovementPayload): SagaIterator {
  return apiClient.post('eld/movements/claim', payload);
}

export function rejectMovementsApi(payload: UpdateMovementPayload): SagaIterator {
  return apiClient.post('eld/movements/reject', payload);
}

export function acceptMovementsApi(payload: UpdateMovementPayload): SagaIterator {
  return apiClient.post('eld/movements/accept', payload);
}
